import { show, hide } from 'redux-modal'
import { CONTENT_MODAL } from 'constant'

export const showContentModal = (data) => show(CONTENT_MODAL, { data })

export const hideContentModal = () => hide(CONTENT_MODAL)
